import React from 'react';
import { ListingStickyFooter } from 'ui/listing-sticky-footer';
import type { ActionsSectionData } from './types';

interface ActionsStickyFooterVariantProps {
  data: ActionsSectionData;
}

/**
 * Actions Sticky Footer Variant
 * 
 * Mobile sticky footer with primary CTA, share, and favorite buttons.
 * Uses primaryAction for "Request Info" and secondaryAction for "Book Showing".
 */
export function ActionsStickyFooterVariant({
  data,
}: ActionsStickyFooterVariantProps) {
  return (
    <ListingStickyFooter
      onRequestInfo={data.primaryAction.onClick}
      onBookShowing={data.secondaryAction?.onClick || data.primaryAction.onClick}
      isComingSoon={data.isComingSoon}
      share={data.share}
      favorite={data.favorite}
    />
  );
}
